import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useGetOvensQuery } from "../../../features/processing/cooking/cookingApi";
import TimeSvg from "../../../images/time.svg";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import MultiSelectBox from "./MultiSelectBox";
import InputWithLabel from "./InputWithLabel";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone } from "../../../helpers/Utils";

const FilterComponent = ({ onApplyFilter, date, onClose }) => {
  const [type, setType] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [ovenIds, setOvenIds] = useState([]);
  const [timeEnteredStart, setTimeEnteredStart] = useState("");
  const [timeEnteredEnd, setTimeEnteredEnd] = useState("");
  const [timeEndStart, setTimeEndStart] = useState("");
  const [timeEndEnd, setTimeEndEnd] = useState("");
  const { _t } = useTranslator();

  const handleApply = (e) => {
    e.preventDefault();

    const formatDateTime = (time) => {
      if (!time || !date) return "";
      const formattedDate = convertToUserTimezone(date, "YYYY-MM-DD"); // Convert date to YYYY-MM-DD
      return `${formattedDate} ${time}:00`; // Format as YYYY-MM-DD HH:MM:SS
    };

    const filters = {};

    if (type) filters.type = type;
    if (filterDate) filters.date = filterDate;
    if (ovenIds.length > 0) filters.oven_id = ovenIds;
    if (timeEnteredStart)
      filters["time_entered[start]"] = formatDateTime(timeEnteredStart);
    if (timeEnteredEnd)
      filters["time_entered[end]"] = formatDateTime(timeEnteredEnd);
    if (timeEndStart) filters["time_end[start]"] = formatDateTime(timeEndStart);
    if (timeEndEnd) filters["time_end[end]"] = formatDateTime(timeEndEnd);

    onApplyFilter(filters); // Pass only set values to parent
    if (onClose) {
      onClose(); // Close the filter dropdown
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setType("");
    setOvenIds([]);
    setTimeEnteredStart("");
    setTimeEnteredEnd("");
    setTimeEndStart("");
    setTimeEndEnd("");
    setFilterDate("");
    onApplyFilter({}); // Reset filters in parent component
  };

  const { data: ovenList } = useGetOvensQuery();

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter", "Filter")}</h5>
      <Form>
        <SelectBox
          label="Type"
          name="type"
          value={type}
          options={[
            { value: "cheeks", label: _t("cheeks", "Cheeks") },
            { value: "strips", label: _t("strips", "Strips") },
            { value: "cheeks/strips", label: _t("cheeks_strips", "Cheeks/Strips") },
          ]}
          onChange={(e) => setType(e.target.value)}
        />

        <MultiSelectBox
          label={_t("select_oven", "Select Oven")}
          name="oven_id"
          value={ovenIds}
          options={ovenList?.data.map((list) => ({
            value: list.id,
            label: _t(list.name, list.name),
          }))}
          onChange={(value) => setOvenIds(value)}
        />
        <InputWithLabel
          label={_t("date", "Date")}
          type="date"
          name="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
        />

        {/* <label className="cmn_label form-label">{_t("time_entered", "Time Entered")}</label>
        <div className="d-flex gap-2 align-items-end justify-content-between">
          <InputWithLabel
            label={_t("start_time", "Start Time")}
            type="time"
            name="time_entered_start"
            value={timeEnteredStart}
            onChange={(e) => setTimeEnteredStart(e.target.value)}
            className="flex-grow-1"
          />
          <InputWithLabel
            label={_t("end_time", "End Time")}
            type="time"
            name="time_entered_end"
            value={timeEnteredEnd}
            onChange={(e) => setTimeEnteredEnd(e.target.value)}
            className="flex-grow-1"
          />
          <span className="icon_filter">
            <img src={TimeSvg} alt="Time Entered Icon" />
          </span>
        </div>

        <label className="cmn_label form-label">{_t("time_end", "Time End")}</label>
        <div className="d-flex gap-2 align-items-end justify-content-between">
          <InputWithLabel
            label={_t("start_time", "Start Time")}
            type="time"
            name="time_end_start"
            value={timeEndStart}
            className="flex-grow-1"
            onChange={(e) => setTimeEndStart(e.target.value)}
          />
          <InputWithLabel
            label={_t("end_time", "End Time")}
            type="time"
            name="time_end_end"
            value={timeEndEnd}
            onChange={(e) => setTimeEndEnd(e.target.value)}
            className="flex-grow-1"
          />
          <span className="icon_filter">
            <img src={TimeSvg} alt="Time End Icon" />
          </span>
        </div> */}

        <div className="d-flex justify-content-between mt-3">
          <Button onClick={handleReset} label={_t("reset", "Reset")} className="reset_btn" />
          <Button className="cmn_btn" label={_t("apply", "Apply")} onClick={handleApply} />
        </div>
      </Form>
    </div>
  );
};

export default FilterComponent;
